(function () {
  function hasAuctionWidget() {
    return !!(
      document.getElementById("auction_app") ||
      document.querySelector(".auction-app, .auction_app, .auction-widget") ||
      document.querySelector('div[id*="auction"], div[class*="auction"]')
    );
  }

  function enableAuctionMode() {
    if (hasAuctionWidget()) {
      document.body.classList.add("auction-today-active");
    }
  }

  // Run now
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enableAuctionMode);
  } else {
    enableAuctionMode();
  }

  // Watch for late injection (Auction Today often injects after load)
  const observer = new MutationObserver(function () {
    if (hasAuctionWidget()) {
      document.body.classList.add("auction-today-active");
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
